import { type PurchasePlanSettings } from '@components/PricingPlans';
import { useQuery } from '@tanstack/react-query';
import { getUserPlanSettings } from '@services/youtube-platform.service';

export const hasReachedPlanLimit = (count: number, limit: number | null | undefined): boolean => {
  if (limit == null) return false;
  return count >= limit;
};

export const usePurchasePlan = (billingAccountOwnerID: string | undefined) => {
  const { data: userPlan } = useQuery({
    queryKey: ['purchase-plan', billingAccountOwnerID],
    queryFn: () => getUserPlanSettings(billingAccountOwnerID),
    enabled: () => {
      if (!billingAccountOwnerID) return false;
      return true;
    }
  });

  const newPlans = [
    'Enterprise',
    'SAStarter-Monthly',
    'SAStarter-Yearly',
    'SAPro-Monthly',
    'SAPro-Yearly',
    'StreamAlive Pro Plan Monthly',
    'StreamAlive Pro Plan Annual',
    'SAScale-Monthly',
    'SAScale-Yearly',
  ];

  const name = (userPlan?.entity?.name || '') as string;
  const isFreePlan = name.toLowerCase().includes('free');
  const isProTrial = name === 'SAPro-Trial';
  const isOldPlan = !isFreePlan && !isProTrial && !newPlans.includes(name);

  return {
    isOldPlan,
    isFreePlan,
    isProTrial,
    name,
    settings: (userPlan?.entity?.settings || {}) as PurchasePlanSettings
  };
};
